import { render } from "./convention.vue?vue&type=template&id=e69fabda&scoped=true"
import script from "./convention.vue?vue&type=script&lang=js"
export * from "./convention.vue?vue&type=script&lang=js"

import "./convention.vue?vue&type=style&index=0&id=e69fabda&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e69fabda"

export default script